namespace SorAraBul.Web.Modules {
    export namespace UserCreditLogPermissions {
        export const View = "UserCreditLog:View";
    }
}
